import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class FAQ extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.text', '');
  }

  get subtitle() {
    return get(this, '_subtitle.text', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/TitleAndSubtitle.js